import { jsx } from "react/jsx-runtime";
import DownloadIcon from "@mui/icons-material/Download";
import { validateTidalLicense } from "../../base/index.js";
function Download(props) {
  return /* @__PURE__ */ jsx(
    DownloadIcon,
    {
      "data-testid": "Download",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Download",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Download.tidalIconMeta = {
  categories: "fileActions",
  name: "Download"
};
validateTidalLicense();
export {
  Download
};
//# sourceMappingURL=Download.js.map
